import { useLocation, Link } from "react-router-dom";

const PaymentFailed = () => {
  const query = new URLSearchParams(useLocation().search);
  const txnid = query.get("txnid");

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>❌ Payment Failed</h1>
      <p>Transaction ID: {txnid}</p>
      <Link to="/bookdestination">Try Again</Link>
    </div>
  );
};

export default PaymentFailed;